import { useEffect, useState } from 'react';
import { dao } from '@platform/dao';
import { knownAssignedBySupport, probeAssignedBySupport } from './assignedByProbe';

/**
 * Чи API списку вже приймає фільтр «призначив» (`assignedBy`, хто останнім призначив виконавця — за історією): пробний запит однієї сторінки
 * з `assignedBy:empty` — один на сесію вкладки (assignedByProbe), а не на кожне відкриття панелі; відмова валідації — фільтр ще не
 * підтримується, тоді швидке поле «Призначив» недоступне з поясненням.
 */
export function useAssignedBySupport(ws: string, rt: string, enabled: boolean): boolean {
  const [ok, setOk] = useState(() => knownAssignedBySupport() ?? false);
  useEffect(() => {
    if (!enabled || !ws || !rt) return undefined;
    let live = true;
    void probeAssignedBySupport(() => dao.records.list(ws, rt, { filter: 'assignedBy:empty', page: 1, pageSize: 10, facets: false }))
      .then((value) => { if (live) setOk(value); });
    return () => { live = false; };
  }, [ws, rt, enabled]);
  return enabled && ok;
}
